import {
  rfi1FinishedGoodSectionMapper,
  rfi2FinishedGoodSectionMapper,
  rfi1FabricSectionMapper,
  rfi2FabricSectionMapper,
  rfi1TrimSectionMapper,
  rfi2TrimSectionMapper,
  rfi1PackagingSectionMapper,
  rfi2PackagingSectionMapper,
} from '../../../../globalComponents/RfiConstants'
import { rfi1RawMaterialSectionMapper } from '../../../../globalComponents/RfiConstants/rfiRawMaterialSectionMapper'
import { rfi2RawMaterialSectionMapper } from '../../../../globalComponents/RfiConstants/rfi2RawMaterialSectionMapper'
import { rfi2SecondaryProcessingSectionMapper } from '../../../../globalComponents/RfiConstants/rfi2SecondaryProcessingMapper'
import {
  RFI_TYPE_SUPPLIER,
  MANUFACTURING_TYPE_ID_FABRIC,
  MANUFACTURING_TYPE_ID_FINISHED_GOOD,
  MANUFACTURING_TYPE_ID_TRIM,
  MANUFACTURING_TYPE_ID_PACKAGING,
  MANUFACTURING_TYPE_ID_RAWMATERIAL,
  MANUFACTURING_TYPE_ID_SECONDARY_PROCESSING,
} from '../../../../common/commonConstants'

export function resolveTemplateMapper(rfiType, manufacturingTypeId) {
  const type = String(manufacturingTypeId)
  const isSupplier = (rfiType || '').toLowerCase() === RFI_TYPE_SUPPLIER

  if (type === String(MANUFACTURING_TYPE_ID_FABRIC)) {
    return isSupplier ? rfi1FabricSectionMapper : rfi2FabricSectionMapper
  }
  if (type === String(MANUFACTURING_TYPE_ID_FINISHED_GOOD)) {
    return isSupplier
      ? rfi1FinishedGoodSectionMapper
      : rfi2FinishedGoodSectionMapper
  }
  if (type === String(MANUFACTURING_TYPE_ID_TRIM)) {
    return isSupplier ? rfi1TrimSectionMapper : rfi2TrimSectionMapper
  }
  if (type === String(MANUFACTURING_TYPE_ID_PACKAGING)) {
    return isSupplier ? rfi1PackagingSectionMapper : rfi2PackagingSectionMapper
  }
  if (type === String(MANUFACTURING_TYPE_ID_RAWMATERIAL)) {
    return isSupplier
      ? rfi1RawMaterialSectionMapper
      : rfi2RawMaterialSectionMapper
  }
  if (type === String(MANUFACTURING_TYPE_ID_SECONDARY_PROCESSING)) {
    // matches old: only RFI2 has secondary-processing mapper
    return !isSupplier && rfi2SecondaryProcessingSectionMapper
  }

  return isSupplier
    ? rfi1FinishedGoodSectionMapper
    : rfi2FinishedGoodSectionMapper
}
